import styled from 'styled-components';

export const WrapperSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
